/**
 * Icons.module.css - 통일된 아이콘 색상 시스템
 * 
 * 색상 규칙:
 * - 기본: 회색 (#9E9E9E)
 * - 호버: 오렌지 (#FF6B00)
 * - 포커스: 기존 포커스 색상
 * - 오렌지 배경: 흰색 (부모에서 설정)
 */

/* ============================================================ */
/* 기본 아이콘 스타일 */
/* ============================================================ */

.icon {
  display: inline-block;
  /* globals.css에서 transition-smooth와 flex-shrink-0 유틸리티 사용 가능 */
}

/* 상호작용 가능한 아이콘 */
.interactive {
  cursor: pointer;
}

/* 호버 효과: 오렌지색으로 변경 */
.interactive:hover {
  --icon-stroke-color: var(--color-brand-primary);
  transform: scale(1.05);
}

/* 색상 오버라이드 클래스들 - 필요시에만 사용 */
.primary {
  --icon-stroke-color: var(--color-brand-primary) !important;
}

.secondary {
  --icon-stroke-color: var(--color-text-secondary) !important;
}

.success {
  --icon-stroke-color: var(--color-success) !important;
}

.danger {
  --icon-stroke-color: var(--color-danger) !important;
}

.warning {
  --icon-stroke-color: var(--color-warning) !important;
}

/* 포커스 효과는 globals.css의 *:focus-visible에서 자동 적용됨 */
.interactive:focus-visible {
  border-radius: 2px;
}

/* ============================================================ */
/* 접근성 개선 */
/* ============================================================ */

/* 고대비 모드 지원 */
@media (prefers-contrast: high) {
  .icon {
    filter: contrast(1.2);
  }
}

/* 모션 감소 설정 지원 */
@media (prefers-reduced-motion: reduce) {
  .icon {
    transition: none;
  }

  .interactive:hover {
    transform: none;
  }
}
